<mat-card class="cardT controle-financas-titulo">
  <span>Controle Finanças</span>

  <span class="controle-financas-acoes">
    <button
      mat-icon-button
      type="button"
      matTooltip="Períodos"
      [class.controle-financas-acao--ativa]="modoExibicao === 'periodos'"
      [disabled]="modoExibicao === 'periodos'"
      (click)="exibirPeriodos()">
      <mat-icon>account_balance</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Buscar Movimentações"
      [class.controle-financas-acao--ativa]="modoExibicao === 'movimentacoes'"
      [disabled]="modoExibicao === 'movimentacoes'"
      (click)="onBuscarMovimentacoes()">
      <mat-icon>search</mat-icon>
    </button>
  </span>
</mat-card>
<div *ngIf="modoExibicao === 'periodos'">
  <app-lista-dados
    [upTitulo]="'Períodos'"
    [upIcone]="'account_balance'"
    [upCor]="'3f51b5'"
    [upDados]="dadosControleFinancas"
    [upColunas]="colunasListaDados"
    [upCarregando]="!!subscription"
    [upHabilitaBotaoIncluir]="true"
    [upHabilitaBotaoEditar]="true"
    [upHabilitaBotaoExcluir]="true"
    [upHabilitaFiltroRapido]="true"
    [upHabilitaPaginacao]="false"
    [upHabilitaContador]="true"
    [upItensPorPagina]="12"
    [upOpcoesItensPorPagina]="[12, 24, 36, 48, 60]"
    [upClasseLinha]="classeLinha.bind(this)"
    (ueBotaoIncluir)="onCreateYear()"
    (ueBotaoEditar)="onEdit($event)"
    (ueBotaoExcluir)="onDelete($event)">
  </app-lista-dados>
</div>

<app-controle-financa-movimentos-filtro
  *ngIf="modoExibicao === 'movimentacoes'">
</app-controle-financa-movimentos-filtro>
